import "./navbar.scss";
import { useContext, useState, useEffect } from "react";
import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

import { DarkModeContext } from "../../context/darkModeContext";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { useLocation } from "react-router-dom";
import { serverUrl } from "../../temp";
import SidebarToggle from "../sidebartoggle/SidebarToggle";
import NotificationSettings from "../notification/NotificationSettings";
const Navbar = () => {
  const { pathname } = useLocation();
  const { darkMode, dispatch } = useContext(DarkModeContext);
  const [fullscreen, setFullscreen] = useState(false);
  const [data, setData] = useState(null);
  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [selectedCenterName, setSelectedCenterName] = useState(""); // New state for name
  const [loading, setLoading] = useState(false);
  const [selectionLocked, setSelectionLocked] = useState(false);
  const [loadingCenters, setLoadingCenters] = useState(false);
  const [showNotificationSettings, setShowNotificationSettings] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const centerId = localStorage.getItem("center_id");
  const userId = data?.id || localStorage.getItem("admin_id");

  const isHomePage = pathname === "/home";

  // Initialize from localStorage
  useEffect(() => {
    const savedCenterId = localStorage.getItem("center_id");
    const savedCenterName = localStorage.getItem("center_name"); // Store name too

    if (savedCenterId) {
      setSelectedCenter(savedCenterId);
      setSelectedCenterName(savedCenterName || savedCenterId); // Fallback to ID if no name
    }

    const adminData = JSON.parse(localStorage.getItem("admindata"));
    if (adminData) {
      setData(adminData);
      if (adminData.role_id == 0 && isHomePage) {
        // if (adminData.role_id == 0) {
        fetchCenters();
      }
    }
  }, [isHomePage]);

  // Lock selection when leaving home page
  useEffect(() => {
    setSelectionLocked(!isHomePage && !!selectedCenter);
  }, [isHomePage, selectedCenter]);

  const fetchCenters = async () => {
    setLoading(true);
    setLoadingCenters(true);
    try {
      const response = await fetch(`${serverUrl}/center_id`);
      const result = await response.json();

      if (result.status === "true" && result.data?.length > 0) {
        const centerOptions = result.data.map((c) => ({
          id: c.id.toString(),
          name: c.name,
        }));
        setCenters(centerOptions);

        // Update name if we have new data
        if (selectedCenter) {
          const currentCenter = centerOptions.find(
            (c) => c.id == selectedCenter
          );
          if (currentCenter) {
            setSelectedCenterName(currentCenter.name);
            localStorage.setItem("center_name", currentCenter.name);
          }
        } else if (centerOptions.length > 0) {
          // Set default if no selection
          setSelectedCenter(centerOptions[0].id);
          setSelectedCenterName(centerOptions[0].name);
          localStorage.setItem("center_id", centerOptions[0].id);
          localStorage.setItem("center_name", centerOptions[0].name);
        }
      }
    } catch (error) {
      console.error("Error fetching centers:", error);
    } finally {
      setLoading(false);
      setLoadingCenters(false);
    }
  };

  const handleCenterChange = (event) => {
    const newCenterId = event.target.value;
    const selectedCenter = centers.find((c) => c.id === newCenterId);

    setSelectedCenter(newCenterId);
    setSelectedCenterName(selectedCenter?.name || newCenterId);
    localStorage.setItem("center_id", newCenterId);
    localStorage.setItem("center_name", selectedCenter?.name || newCenterId);
  };

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      setFullscreen(false);
    } else {
      document.documentElement.requestFullscreen();
      setFullscreen(true);
    }
  };

  return (
    <div className="navbar">
      <div className="wrapper">
        <div className="left-section">
          <SidebarToggle />
        </div>
        {/* <div className="items !hidden !lg:flex">
          <div className="item">
            <FullscreenExitOutlinedIcon
              className="icon"
              onClick={toggleFullscreen}
            />
          </div>
          <div className="logo">{data ? data.name : "Abbas"}</div>
        </div> */}
        {data?.role_id == 0 && (
          // <FormControl size="small" className="mr-2" sx={{ minWidth: 200 }}>
          //   <InputLabel>Select Center</InputLabel>
          //   <Select
          //     value={selectedCenter}
          //     onChange={handleCenterChange}
          //     disabled={loading || selectionLocked}
          //     displayEmpty
          //     renderValue={() => selectedCenterName || "Select a center"}
          //   >
          //     {loading ? (
          //       <MenuItem disabled>Loading...</MenuItem>
          //     ) : centers.length === 0 ? (
          //       <MenuItem disabled>No centers available</MenuItem>
          //     ) : (
          //       centers.map((center) => (
          //         <MenuItem key={center.id} value={center.id}>
          //           {center.name}
          //         </MenuItem>
          //       ))
          //     )}
          //   </Select>
          // </FormControl>
          <div className="horizontal-dropdown">
            <label className="dropdown-label">Center</label>
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <Select
                value={selectedCenter}
                onChange={handleCenterChange}
                disabled={loading || selectionLocked}
                displayEmpty
                renderValue={() => selectedCenterName || "Select Center"}
              >
                {loadingCenters ? (
                  <MenuItem disabled>Loading centers...</MenuItem>
                ) : centers.length === 0 ? (
                  <MenuItem disabled>No centers available</MenuItem>
                ) : (
                  centers.map((center) => (
                    <MenuItem key={center.id} value={center.id}>
                      {center.name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </div>
        )}
        
        <div className="right-section">
          {/* Notification Bell */}
          <div className="item">
            <Badge badgeContent={notificationCount} color="error">
              <NotificationsIcon 
                className="icon" 
                onClick={() => setShowNotificationSettings(!showNotificationSettings)}
                style={{ cursor: 'pointer' }}
              />
            </Badge>
          </div>
          
          {/* Fullscreen Toggle */}
          {data?.role_id != 0 && (
            <div className="item hidden lg:block">
              {fullscreen ? (
                <FullscreenExitOutlinedIcon className="icon" onClick={toggleFullscreen} />
              ) : (
                <FullscreenOutlinedIcon className="icon" onClick={toggleFullscreen} />
              )}
            </div>
          )}
        </div>
      </div>
      
      {/* Notification Settings Modal */}
      {/* <Modal
        open={showNotificationSettings}
        onClose={() => setShowNotificationSettings(false)}
        aria-labelledby="notification-settings-modal"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
        }}>
          <NotificationSettings 
            userId={userId}
            centerId={centerId}
            inModal={true}
          />
        </Box>
      </Modal> */}
      <Modal
        open={showNotificationSettings}
        onClose={() => setShowNotificationSettings(false)}
        aria-labelledby="notification-settings-modal"
      >
        <div
          className="
      absolute 
      top-1/2 left-1/2 
      -translate-x-1/2 -translate-y-1/2
      w-[95%] sm:w-[450px] 
      bg-white
      rounded-xl 
      shadow-2xl 
      p-5 sm:p-6
      max-h-[85vh] 
      overflow-y-auto
    "
        >

          <NotificationSettings
            userId={userId}
            centerId={centerId}
            inModal={true}
          />
        </div>
      </Modal>

    </div>
  );
};

export default Navbar;
